<template>
  <div>
    <!-- Figma UQ "Equipment Info - Step 1/4" + "Quote Summary - Upload Images": note, "Upload images" (outlined while
         empty, solid once there are photos, like the S&R gallery) + max-8 hint, then the shared photo grid -->
    <div class="flex flex-col gap-[15px] font-roboto">
      <p class="m-0 text-[16px] font-normal leading-tight text-[#333333]">
        {{ isBefore == 1 ? 'Add images for the system before evaluation and fixing.' :
          'Add images for the system after evaluation and fixing.' }}
      </p>
      <div class="flex flex-wrap items-center gap-[10px]">
        <button type="button" :disabled="images.length >= 8"
          class="group flex items-center justify-center gap-[8px] w-[150px] h-[36px] rounded-[5px] border-1 text-[14px] transition-all duration-300 disabled:cursor-not-allowed disabled:!bg-white disabled:!border-[#CCCCCC] disabled:!text-[#CCCCCC]"
          :class="images.length ? 'border-[#7695FF] bg-[#7695FF] text-white' : 'border-[#7695FF] bg-[#fff] text-[#7695FF] hover:bg-[#7695FF] hover:text-white [@media(hover:none)]:bg-[#7695FF] [@media(hover:none)]:text-white'"
          @click="image">
          Upload images
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M7 18a4.5 4.5 0 0 1-.6-8.96A6 6 0 0 1 18 8.5a4 4 0 0 1-.5 7.97M12 12v7m0-7-2.5 2.5M12 12l2.5 2.5"
              stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
        <span class="text-[12px] text-[#F67280]">(Maximum 8 images allowed)</span>
        <input ref="fileInput" type="file" class="hidden" accept="image/png,image/jpg,image/jpeg"
          @change="updateImageDisplay">
      </div>
      <PhotoGallery v-if="images.length" :files="images" alt-text="System photo" @remove="deleteImageModal" />
    </div>
  </div>
  <div id="deleteImageModal" ref="deleteImageModalRef" class="modal fade fxModal fxConfirm" data-bs-backdrop="static" tabindex="-1"
    aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered mobile:!w-full mobile:!right-0 mobile:!px-3 tablet:px-0 tablet:!w-[450px] !absolute tablet:!right-4 !top-0 !m-0 h-full">
      <div class="modal-content">
        <div class="modal-body">
          <ConfirmLayout title="Delete Image" button-text="Continue" @close="closedeleteImageModal()"
            @confirm="continuedeleteImage(selectedImage)">
            Are you sure you want to delete this image?
          </ConfirmLayout>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useToast } from "vue-toastification";
const toast = useToast();
import { mapActions, mapGetters } from "vuex";
import { disableScroll, enableScroll } from "../../helpers/scrollHelper";
import { Modal } from "bootstrap";
import PhotoGallery from "../gallery/PhotoGallery.vue";
import ConfirmLayout from "../confirmDialog/ConfirmLayout.vue";

export default {
  components: {
    PhotoGallery,
    ConfirmLayout,
  },
  props: ["isBefore"],

  data() {
    return {
      images: [],
      type: "",
      selectedImage: null,
    };
  },
  computed: {
    ...mapGetters([
      "quoteDetail",
      "quoteImageUploaded",
      "quoteImages",
      "deleteQuoteImage",
    ]),
  },

  watch: {
    deleteQuoteImage: function () {
      if (this.deleteQuoteImage) {
        this.updateDeletedQuoteImages();
        this.getImages();
      }
    },

    quoteImageUploaded: function () {
      this.$refs.fileInput.value = ''
      this.images[0].isLoading = false;

      this.images.shift();
      this.images.splice(0, 0, this.quoteImageUploaded);
    },

    quoteImages: function () {
      this.images = this.quoteImages;
    },
  },

  mounted() {
    this.getImages();
  },

  methods: {
    ...mapActions([
      "uploadQuoteImage",
      "getQuoteImages",
      "deleteQuoteImages",
      "updateDeletedQuoteImages",
    ]),
    closedeleteImageModal() {
      enableScroll()
      this.modal.hide();
    },
    deleteImageModal(item) {
      disableScroll()
      this.selectedImage = item;
      this.modal = new Modal(this.$refs.deleteImageModalRef);
      this.modal.show();
    },
    continuedeleteImage(item) {
      this.deleteQuoteImages({
        manual_quote_id: this.$route.params.id,
        id: item.id,
      });
      this.closedeleteImageModal()
    },
    getImages() {
      let params = {
        manual_quote_id: this.$route.params.id,
        is_before: this.isBefore,
      };
      this.getQuoteImages(params);
    },

    uploadImage(e) {
      const file = e.target.files[0];
      let formData = new FormData();
      formData.append("document", file);
      formData.append("manual_quote_id", this.$route.params.id);
      formData.append("is_before", this.isBefore);
      formData.append("index", 0);
      formData.append("timestamp", new Date().getTime());
      this.uploadQuoteImage(formData);
    },

    updateImageDisplay(e) {
      const fileSize = e.target.files[0].size / 1024 / 1024; // in MiB
      const file = event.target.files[0];
      // ✅ Check file type
      if (!["image/png", "image/jpg", "image/jpeg"].includes(file.type)) {
        toast.error("Only PNG, JPG, and JPEG files are allowed!");
        this.$refs.fileInput.value = ''
        return;
      } else if (fileSize <= 10) {
        const file = e.target.files[0];
        let url = URL.createObjectURL(file);
        var obj = {
          isLoading: true,
          url: url,
        };

        this.images.splice(0, 0, obj);
        this.uploadImage(e);
      } else {
        toast.error("File size should not be greater than 10MB.");
        this.$refs.fileInput.value = ''
      }
    },

    image() {
      this.$refs.fileInput.click();
    },

    // optionClicked(data) {
    //   this.$refs.bottomSheet.close();
    //   if (data == 1) {
    //     this.type = "camera";
    //   } else if (data == 2) {
    //     this.type = "gallery";
    //   }
    // },

  },
};
</script>
<style>
.viewer-close {
  width: 36px;
  height: 36px;
  background: url('../../assets/images/gallery-close.svg') no-repeat center center !important;
  background-size: 40px 40px !important;
  opacity: 1 !important;
  top: 10px;
  right: 10px;
}

.viewer-close:focus {
  outline: none !important;
}

.viewer-close::before {
  content: none !important;
  /* default X hata do */
}
</style>
